import type { FaireProductEntity } from "../../entity_types/product";

export const p_rgfk38cn85: FaireProductEntity = {
  token: "p_rgfk38cn85",
  type: "product",
  name: "Solid Color Cropped Tank Top and Jogger Pants Set",
  brandToken: "b_sc7ewms49n",
  brandName: "1 the Woman",
  imageUrl:
    "https://cdn.faire.com/fastly/7c5c04ed1dd11025d5ce7f28a25744be7484086bfcc4b6874e3a83ba7db6a79d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b8208cf3e4b8666601eb36a63967c79d74351481f5a6852b3fd0368bf0f78016.jpeg",
    "https://cdn.faire.com/fastly/0ae681065fa53f9aac3901caa2677ee82db76a666ec47f2d3b5d50c4235ad1ca.jpeg",
    "https://cdn.faire.com/fastly/984ec40b9193ee902e81a047d277af12b84df479554931d322ef172184bdaf6f.jpeg",
    "https://cdn.faire.com/fastly/0ff3cf9bd1469d87a064766b56891135990afd06a95d6e401dde3a8db03825cf.jpeg",
    "https://cdn.faire.com/fastly/cfcfa7adbbb60bcc967beff98d24bb4a7bd49300c32414556a78437bf366ab09.jpeg",
    "https://cdn.faire.com/fastly/c3d8bac7f2351ed8949aaefebe1f0a3368c359db2b24e43a04e1885ed9260e5b.jpeg",
    "https://cdn.faire.com/fastly/59452c7e7a00f1accb403f21a821c4e31e0ef4164d0c78c0a6a9c9248eae958f.jpeg",
    "https://cdn.faire.com/fastly/04ebbbd9e0fb62ed7470679d328e18313cf897722c2793c052dbc76d42e3fedd.jpeg",
    "https://cdn.faire.com/fastly/bdf65ec6bd4e03eadaf25057cea996510c8fd26aefed055844c8e8950a5531f6.jpeg",
    "https://cdn.faire.com/fastly/aeb6c62bb116d9e55a5c3ad105931417933649c31d7ea0d5d5df40c5e595542f.jpeg",
  ],
  priceDollars: 28,
  description:
    "📏 Size:  S-XL\n📐 Material: 95%Cotton+5%Elastane\n✅ Labels: Message us for free stitching if needed\n🎨 Color: Yellow Cream, Racing Red, Beau Blue, Moonlight Jade\n🔘 Pattern: Solid\n🌏Care Instructions: Machine wash cold, tumble dry low\n\n⚫ DESCRIPTION\nMinimalist comfort in coordinated style. This set pairs a solid color cropped tank with matching jogger pants for a sleek, relaxed look.\n\n✨ DESIGN HIGHLIGHTS\n🩱 Fitted cropped tank top\n🩳 Relaxed jogger pants with elastic waist & cuffs\n🧥 Oversized or regular-fit silhouette\n🧶 Soft cotton-blend jersey or French terry fabric\n✨ Ribbed trim on tank and pants\n\n🏃 ♀️ STYLING NOTE\nWear together for a complete loungewear or athleisure look\nMix and match with denim or other casual separates\nPerfect for workouts, errands, or relaxed days at home",
  tags: [],
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:21.445Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
